
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("bzo9I", function(module, exports) {

$parcel$export(module.exports, "getWatchQueryData", () => $86c5b369bdf45181$export$f07a4d3f50d92df5);
$parcel$export(module.exports, "WatchDialog", () => $86c5b369bdf45181$export$7a3e91558b835213);

var $gwFzn = parcelRequire("gwFzn");

var $ipPpS = parcelRequire("ipPpS");

var $j1Ss3 = parcelRequire("j1Ss3");

var $1DWH0 = parcelRequire("1DWH0");

var $7Sm4c = parcelRequire("7Sm4c");

var $ge2sX = parcelRequire("ge2sX");

var $gqqjz = parcelRequire("gqqjz");

var $dIouf = parcelRequire("dIouf");

var $5EoFB = parcelRequire("5EoFB");

var $3joiD = parcelRequire("3joiD");

var $gqsYd = parcelRequire("gqsYd");

var $49Q03 = parcelRequire("49Q03");

var $bl4QJ = parcelRequire("bl4QJ");

var $hpr9b = parcelRequire("hpr9b");
const $86c5b369bdf45181$var$isUserAdmin = (operations)=>{
    return Boolean(operations.find((elem)=>elem.targetType === 'space' && elem.operation === 'administer'));
};
const $86c5b369bdf45181$export$f07a4d3f50d92df5 = (data)=>{
    const spaceId = data?.singleContent?.space?.id;
    const contentType = data?.singleContent?.type;
    const isCurrentUserWatching = data?.singleContent?.currentUserIsWatching;
    const isWatchingChildren = data?.singleContent?.currentUserIsWatchingChildren;
    const hasAncestorWatchingChildren = data?.singleContent?.currentUserHasAncestorWatchingChildren;
    const isWatchingBlogs = data?.singleContent?.space?.currentUser?.isWatchingBlogs;
    const isAdmin = data?.singleContent?.space?.operations || [];
    const isWatchingSpace = data?.singleContent?.space?.currentUser?.isWatched;
    return {
        spaceId: spaceId,
        contentType: contentType,
        isCurrentUserWatching: isCurrentUserWatching,
        isWatchingChildren: isWatchingChildren,
        hasAncestorWatchingChildren: hasAncestorWatchingChildren,
        isWatchingBlogs: isWatchingBlogs,
        isAdmin: isAdmin,
        isWatchingSpace: isWatchingSpace
    };
};
const $86c5b369bdf45181$export$7a3e91558b835213 = (0, $1DWH0.default)()(function WatchDialog({ contentId: contentId, defaultTab: defaultTab, customPlacement: customPlacement, onRender: onRender = ()=>{}, customTrigger: customTrigger, compact: compact, useShortcut: useShortcut = true, componentLocation: componentLocation, isDisabled: isDisabled }) {
    if (!contentId) return null;
    const shouldSSRWatchButton = Boolean(window.__SSR_RENDERED__ && (defaultTab === (0, $5EoFB.MANAGE_WATCHER_TAB_TYPES).PAGE || defaultTab === (0, $5EoFB.MANAGE_WATCHER_TAB_TYPES).SPACE));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).COLLABORATION
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ge2sX.SessionData), null, ({ isLicensed: isLicensed, userId: userId, edition: edition })=>{
        if (!userId) return null;
        const skipTrialDetailsQuery = !isLicensed || edition === (0, $gqsYd.CONFLUENCE_EDITION).FREE;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ipPpS.Subscribe), {
            to: [
                (0, $gqqjz.FlagsStateContainer)
            ]
        }, (flagsContainer)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $j1Ss3.Query), (0, $3joiD.getQueryPropsAndSetFetchPolicyForNetworkOnlyQuery)({
                query: (0, $hpr9b.getWatchDialogQuery)(),
                variables: {
                    contentId: contentId
                },
                skip: !isLicensed,
                context: {
                    single: true
                }
            }), ({ data: data, loading: loading, error: error })=>{
                if (error) {
                    if ((0, $dIouf.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
                    return null;
                }
                if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bl4QJ.WatchButtonPlaceholder), {
                    compact: compact
                });
                const { spaceId: spaceId, contentType: contentType, isCurrentUserWatching: isCurrentUserWatching, isWatchingChildren: isWatchingChildren, hasAncestorWatchingChildren: hasAncestorWatchingChildren, isWatchingBlogs: isWatchingBlogs, isAdmin: isAdmin, isWatchingSpace: isWatchingSpace } = $86c5b369bdf45181$export$f07a4d3f50d92df5(data);
                const params = {
                    isWatchingContent: isCurrentUserWatching,
                    isWatchingChildren: isWatchingChildren,
                    hasAncestorWatchingChildren: hasAncestorWatchingChildren,
                    isWatchingBlogs: isWatchingBlogs,
                    isWatchingSpace: isWatchingSpace,
                    isAdmin: $86c5b369bdf45181$var$isUserAdmin(isAdmin),
                    edition: edition
                };
                onRender();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $49Q03.WatchDialogComponent), {
                    contentId: contentId,
                    spaceId: spaceId,
                    params: params,
                    defaultTab: defaultTab,
                    flagsContainer: flagsContainer,
                    customPlacement: customPlacement,
                    isDisabled: !isLicensed || isDisabled,
                    customTrigger: customTrigger,
                    useShortcut: useShortcut,
                    shouldSSRWatchButton: shouldSSRWatchButton,
                    skipTrialDetailsQuery: skipTrialDetailsQuery,
                    contentType: contentType,
                    componentLocation: componentLocation
                });
            }));
    }));
});

});
parcelRegister("49Q03", function(module, exports) {

$parcel$export(module.exports, "WatchDialogComponent", () => $47908050ea4fd9b1$export$4b54507e0234ad87);

var $gwFzn = parcelRequire("gwFzn");

var $j1Ss3 = parcelRequire("j1Ss3");

var $2nPZH = parcelRequire("2nPZH");
var $js7oX = parcelRequire("js7oX");

var $fppBw = parcelRequire("fppBw");

var $lGgRw = parcelRequire("lGgRw");

var $inPa6 = parcelRequire("inPa6");

var $gqqjz = parcelRequire("gqqjz");

var $lOkIA = parcelRequire("lOkIA");

var $jmjWc = parcelRequire("jmjWc");

var $b8XTE = parcelRequire("b8XTE");

var $irVI7 = parcelRequire("irVI7");
var $1eaCJ = parcelRequire("1eaCJ");
var $1kHsc = parcelRequire("1kHsc");

var $7zgzO = parcelRequire("7zgzO");

var $g1WP0 = parcelRequire("g1WP0");

var $hpr9b = parcelRequire("hpr9b");

var $20FI0 = parcelRequire("20FI0");

var $9SsRl = parcelRequire("9SsRl");

var $2REhP = parcelRequire("2REhP");

var $sRTqL = parcelRequire("sRTqL");

var $jle6C = parcelRequire("jle6C");

const $47908050ea4fd9b1$export$9c5737ae30e94007 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "aohZt",
    name: "LazyWatchDialogContent",
    loader: async ()=>(await (parcelRequire("h95iD"))).WatchDialogContent,
    // eslint-disable-next-line react/prop-types
    loading: ({ shouldSSRWatchButton: shouldSSRWatchButton })=>// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
            style: {
                width: '325px',
                height: '180px'
            }
        }, !shouldSSRWatchButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lOkIA.CenteredSpinner), {
            size: "medium"
        }))
});

const $47908050ea4fd9b1$var$LazyWatchDialogShortcut = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "gDGxN",
    name: "LazyWatchDialogShortcut",
    loader: async ()=>(await (parcelRequire("iIsfI"))).WatchDialogShortcut
});
const $47908050ea4fd9b1$var$i18n = (0, $2nPZH.defineMessages)({
    watchContentDialogLabel: {
        id: "watch-dialog.popup.label",
        defaultMessage: "Watch content dialog"
    }
});
const $47908050ea4fd9b1$export$4b54507e0234ad87 = (0, $js7oX.default)(({ contentId: contentId, spaceId: spaceId, params: params, defaultTab: defaultTab, customPlacement: customPlacement, flagsContainer: flagsContainer, isDisabled: /**
   * This disables the usage of the watch button and dialog.
   *
   * Note: If a `customTrigger` is provided, this will be passed through
   * as `isDisabled`. However, as a fallback, even if the button is not
   * disabled properly, the logic here will continue to be disabled.
   */ isDisabled, customTrigger: customTrigger, useShortcut: useShortcut, shouldSSRWatchButton: shouldSSRWatchButton, skipTrialDetailsQuery: skipTrialDetailsQuery, contentType: contentType, componentLocation: componentLocation, intl: intl })=>{
    const [hasRecentlyUnwatchedContent, setHasRecentlyUnwatchedContent] = (0, $gwFzn.useState)(false);
    const [dialogOpen, setDialogOpen] = (0, $gwFzn.useState)(false);
    const [shouldOpenWatchDialogFromQueryParams, setShouldOpenWatchDialogFromQueryParams] = (0, $gwFzn.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const experienceTracker = (0, $gwFzn.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { getQueryParams: getQueryParams, setQueryParams: setQueryParams } = (0, $gwFzn.useContext)((0, $7zgzO.RoutesContext));
    const nudgeRef = (0, $gwFzn.useRef)(null);
    const { isWatchingContent: isWatchingContent, isWatchingChildren: isWatchingChildren, hasAncestorWatchingChildren: hasAncestorWatchingChildren, isWatchingSpace: isWatchingSpace } = params;
    (0, $gwFzn.useEffect)(()=>{
        if (isDisabled) return;
        const { openWatchModal: openWatchModal } = getQueryParams();
        setShouldOpenWatchDialogFromQueryParams(openWatchModal === 'true' && (componentLocation === (0, $2REhP.WATCH_DIALOG_LOCATION).SPACE_OVERVIEW || componentLocation === (0, $2REhP.WATCH_DIALOG_LOCATION).PAGE));
        if (shouldOpenWatchDialogFromQueryParams) setDialogOpen(true);
    }, [
        isDisabled,
        getQueryParams,
        componentLocation,
        shouldOpenWatchDialogFromQueryParams
    ]);
    const removeOpenModalQueryParams = ()=>{
        const queryParams = getQueryParams();
        if (queryParams.openWatchModal) {
            setQueryParams({
                ...queryParams,
                openWatchModal: undefined
            }, true);
            setShouldOpenWatchDialogFromQueryParams(false);
        }
    };
    const toggleDialog = (0, $gwFzn.useCallback)(()=>{
        // Do not enable open the dialog if watch is disabled
        if (isDisabled) return;
        setDialogOpen((prevState)=>!prevState);
    }, [
        isDisabled
    ]);
    const isWatching = (0, $gwFzn.useCallback)(()=>{
        // If watch is disabled, then the user will default to not watching
        return isDisabled ? false : isWatchingContent || isWatchingSpace || isWatchingChildren || hasAncestorWatchingChildren;
    }, [
        isWatchingContent,
        isWatchingChildren,
        hasAncestorWatchingChildren,
        isWatchingSpace,
        isDisabled
    ]);
    const updateQueryHandler = (cache, contentType, newDataValue)=>{
        const query = (0, $hpr9b.getWatchDialogQuery)();
        const contentData = cache.readQuery({
            query: query,
            variables: {
                contentId: contentId
            }
        });
        switch(contentType){
            case (0, $jle6C.UpdateContentType).CONTENT:
                contentData.singleContent.currentUserIsWatching = newDataValue;
                break;
            case (0, $jle6C.UpdateContentType).CHILDREN:
                contentData.singleContent.currentUserIsWatchingChildren = newDataValue;
                break;
            case (0, $jle6C.UpdateContentType).SPACE:
                contentData.singleContent.space.currentUser.isWatched = newDataValue;
                break;
            default:
                contentData.singleContent.space.currentUser.isWatchingBlogs = newDataValue;
                break;
        }
        cache.writeQuery({
            query: query,
            data: contentData
        });
    };
    const fireWatchAnalyticsEvent = (0, $gwFzn.useCallback)((action, actionSubject)=>{
        const analyticsData = {
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: contentId,
            objectId: contentId,
            objectType: contentType,
            source: 'WatchButton'
        };
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: analyticsData
        }).fire();
    }, [
        createAnalyticsEvent,
        contentId,
        contentType
    ]);
    const [watchContent] = (0, $j1Ss3.useMutation)((0, $sRTqL.WatchDialogWatchContentMutation), {
        onCompleted: ()=>{
            fireWatchAnalyticsEvent((0, $jle6C.UpdateType).WATCH, (0, $jle6C.UpdateContentType).CONTENT);
            toggleDialog();
            experienceTracker.succeed({
                name: (0, $irVI7.WATCH_DIALOG_WATCH_EXPERIENCE)
            });
        },
        onError: (error)=>{
            experienceTracker.fail({
                name: (0, $irVI7.WATCH_DIALOG_WATCH_EXPERIENCE),
                error: error.message
            });
        },
        update: (cache, { data: { watchContent: watchContent } })=>{
            updateQueryHandler(cache, (0, $jle6C.UpdateContentType).CONTENT, watchContent.content.currentUserIsWatching);
        }
    });
    const handleOneClickWatch = (0, $gwFzn.useCallback)(async ()=>{
        const experienceState = experienceTracker.getExperienceState((0, $irVI7.WATCH_DIALOG_WATCH_EXPERIENCE));
        if (experienceState === null || experienceState.hasStopped) experienceTracker.start({
            name: (0, $irVI7.WATCH_DIALOG_WATCH_EXPERIENCE)
        });
        await watchContent({
            variables: {
                id: contentId
            }
        });
    }, [
        watchContent,
        contentId,
        experienceTracker
    ]);
    const handleWatchButtonClick = (0, $gwFzn.useCallback)(async ()=>{
        if (dialogOpen || isWatching()) toggleDialog();
        else await handleOneClickWatch();
    }, [
        toggleDialog,
        isWatching,
        dialogOpen,
        handleOneClickWatch
    ]);
    const openDialog = ()=>{
        setDialogOpen(true);
    };
    const closeDialog = ()=>{
        setDialogOpen(false);
    };
    const onContentUnwatch = ()=>{
        setHasRecentlyUnwatchedContent(true);
    };
    const renderPopupTrigger = (triggerProps)=>{
        const TriggerButton = customTrigger || (0, $20FI0.WatchButton);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(TriggerButton, {
            isDisabled: isDisabled,
            isWatching: isWatching(),
            isSelected: dialogOpen,
            onMouseOver: $47908050ea4fd9b1$export$9c5737ae30e94007.preload,
            onClick: handleWatchButtonClick,
            triggerProps: triggerProps,
            shouldSSRWatchButton: shouldSSRWatchButton,
            defaultTab: defaultTab,
            contentId: contentId,
            updateQueryHandler: updateQueryHandler,
            hasRecentlyUnwatchedContent: hasRecentlyUnwatchedContent
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: (0, $irVI7.CONTENT_TYPES_HEADER_WATCH_EXPERIENCE),
            attributes: {
                isWatching: isWatching()
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $b8XTE.PageSegmentLoadEnd), {
            key: contentId,
            metric: (0, $9SsRl.WATCH_BUTTON_METRIC)
        }));
    };
    const renderPopupContent = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
            style: {
                padding: `${"var(--ds-space-300, 24px)"} ${"var(--ds-space-200, 16px)"}`
            },
            ref: nudgeRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($47908050ea4fd9b1$export$9c5737ae30e94007, {
            contentId: contentId,
            spaceId: spaceId,
            defaultTab: defaultTab,
            params: params,
            closeWatchDialog: closeDialog,
            updateQueryHandler: updateQueryHandler,
            skipTrialDetailsQuery: skipTrialDetailsQuery,
            contentType: contentType,
            shouldOpenWatchDialogFromQueryParams: shouldOpenWatchDialogFromQueryParams,
            removeOpenModalQueryParams: removeOpenModalQueryParams,
            onContentUnwatch: onContentUnwatch
        })), dialogOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $g1WP0.AsyncWrapper), {
            trigger: "watch-page",
            showImage: false,
            width: 357,
            reference: nudgeRef
        }));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, useShortcut && !isDisabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($47908050ea4fd9b1$var$LazyWatchDialogShortcut, {
        contentId: contentId,
        contentType: contentType,
        params: params,
        flagsContainer: flagsContainer,
        openDialog: openDialog,
        updateQueryHandler: updateQueryHandler
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lGgRw.default), {
        isOpen: dialogOpen,
        onClose: closeDialog,
        content: ()=>renderPopupContent(),
        trigger: renderPopupTrigger,
        placement: customPlacement,
        role: "dialog",
        label: intl.formatMessage($47908050ea4fd9b1$var$i18n.watchContentDialogLabel),
        testId: "watch-content-dialog",
        shouldRenderToParent: true
    }));
});
$47908050ea4fd9b1$export$4b54507e0234ad87.propTypes = {
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string.isRequired,
    spaceId: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string,
    params: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).shape({
        isWatchingContent: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).bool.isRequired,
        isWatchingChildren: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).bool.isRequired,
        hasAncestorWatchingChildren: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).bool.isRequired,
        isWatchingSpace: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).bool.isRequired
    }).isRequired,
    defaultTab: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).number.isRequired,
    customPlacement: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string,
    flagsContainer: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).instanceOf((0, $gqqjz.FlagsStateContainer)),
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).bool,
    customTrigger: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).elementType,
    useShortcut: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).bool,
    shouldSSRWatchButton: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).bool,
    skipTrialDetailsQuery: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).bool,
    contentType: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string,
    componentLocation: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).number
};

});
parcelRegister("20FI0", function(module, exports) {

$parcel$export(module.exports, "WatchButton", () => $176bef54c656e043$export$e149a93a7ac7f896);
/* WatchButton.js generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $fppBw = parcelRequire("fppBw");

var $2nPZH = parcelRequire("2nPZH");
var $js7oX = parcelRequire("js7oX");

var $inPa6 = parcelRequire("inPa6");

var $eEA8O = parcelRequire("eEA8O");

var $fCjCI = parcelRequire("fCjCI");

var $8cjip = parcelRequire("8cjip");

var $3gadb = parcelRequire("3gadb");

var $6cnUO = parcelRequire("6cnUO");
var $5izcQ = parcelRequire("5izcQ");

var $5EoFB = parcelRequire("5EoFB");


var $ljm2R = parcelRequire("ljm2R");

var $efvKr = parcelRequire("efvKr");

var $de2j9 = parcelRequire("de2j9");

var $cMvQV = parcelRequire("cMvQV");

var $i7yn3 = parcelRequire("i7yn3");
const $176bef54c656e043$var$i18n = (0, $2nPZH.defineMessages)({
    startWatchingIconLabel: {
        id: "watch-dialog.watch-button.start.watching.label",
        defaultMessage: "Start watching"
    },
    stopWatchingIconLabel: {
        id: "watch-dialog.watch-button.stop.watching.label",
        defaultMessage: "Stop watching"
    },
    watchStopTooltip: {
        id: "watch-dialog.stop.button.tooltip",
        defaultMessage: "Stop watching"
    },
    watchStartTooltip: {
        id: "watch-dialog.start.button.tooltip",
        defaultMessage: "Watch"
    }
});
const $176bef54c656e043$export$2d5d2ba3c7c8c40b = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = (0, $eEA8O.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_701w1ul9",
            __cmplp.className
        ])
    });
});
const $176bef54c656e043$var$WatchButtonComponent = ({ isDisabled: isDisabled, isWatching: isWatching, isSelected: isSelected, onClick: onClick, onMouseOver: onMouseOver, intl: intl, triggerProps: triggerProps, shouldSSRWatchButton: shouldSSRWatchButton, defaultTab: defaultTab, hasRecentlyUnwatchedContent: hasRecentlyUnwatchedContent })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [{ isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    (0, $gwFzn.useEffect)(()=>{
        // on mount, immediately handle the SSR click since the
        // data from WatchDialogQuery has already been preloaded
        // Additionally, checking window.__SSR_EVENTS_CAPTURE will
        // only have attributes when SSRing View page
        if (shouldSSRWatchButton && window?.__SSR_EVENTS_CAPTURE__?.watchButton) {
            handleWatchButtonClick();
            delete window.__SSR_EVENTS_CAPTURE__.watchButton;
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const fireClickAnalyticsEvent = (0, $gwFzn.useCallback)(()=>{
        const analyticsData = {
            action: 'clicked',
            actionSubject: 'content-watch-button',
            source: 'viewPageScreen'
        };
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: analyticsData
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    const handleWatchButtonClick = ()=>{
        onClick();
        fireClickAnalyticsEvent();
    };
    const onDismissNudgeButtonClick = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'dismissed',
                actionSubject: 'button',
                actionSubjectId: 'WatchDialogWatchContentNudge',
                source: 'WatchButton'
            }
        }).fire();
    };
    const onWatchFromNudgeButtonClick = ()=>{
        onClick();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'watched',
                actionSubject: 'button',
                actionSubjectId: 'WatchDialogWatchContentNudge',
                source: 'WatchButton'
            }
        }).fire();
    };
    const shouldSSRWatchButtonForViewPage = defaultTab === (0, $5EoFB.MANAGE_WATCHER_TAB_TYPES).PAGE;
    const shouldSSRWatchButtonForSOPage = defaultTab === (0, $5EoFB.MANAGE_WATCHER_TAB_TYPES).SPACE;
    const shortcutContent = isWatching ? intl.formatMessage($176bef54c656e043$var$i18n.watchStopTooltip) : intl.formatMessage($176bef54c656e043$var$i18n.watchStartTooltip);
    const getTooltipContent = ()=>{
        if (isDisabled) return undefined;
        if (isLiveEditMode || isOnEditRoute) return shortcutContent;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ljm2R.ShortcutVisualizer), {
            shortcut: (0, $cMvQV.isSafari)() ? (0, $ljm2R.UNIVERSAL_WATCH_CONTENT_SHORTCUT_SAFARI) : (0, $ljm2R.UNIVERSAL_WATCH_CONTENT_SHORTCUT),
            contentBefore: shortcutContent,
            isTooltip: true
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6cnUO.default), {
        blanketIsTinted: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5izcQ.default), {
        name: "content-watch-spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
        tag: "span",
        content: getTooltipContent()
    }, undefined, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($176bef54c656e043$export$2d5d2ba3c7c8c40b, {
        "data-id": "page-watch-button",
        "data-test-id": "page-watch-button",
        testId: "page-watch-button",
        appearance: "subtle",
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleWatchButtonClick,
        onMouseOver: onMouseOver,
        onFocus: onMouseOver,
        iconBefore: isWatching ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fCjCI))), {
            label: intl.formatMessage($176bef54c656e043$var$i18n.stopWatchingIconLabel),
            testId: "watch-filled-icon",
            spacing: "spacious"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8cjip))), {
            label: intl.formatMessage($176bef54c656e043$var$i18n.startWatchingIconLabel),
            testId: "watch-icon",
            spacing: "spacious"
        }),
        ...triggerProps
    }))), !isDisabled && !isWatching && !hasRecentlyUnwatchedContent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $i7yn3.WatchContentNudgeSpotlight), {
        onWatchFromNudgeButtonClick: onWatchFromNudgeButtonClick,
        onDismissNudgeButtonClick: onDismissNudgeButtonClick
    }));
};
$176bef54c656e043$var$WatchButtonComponent.propTypes = {
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).bool,
    isWatching: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).bool.isRequired,
    isSelected: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).bool.isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).func.isRequired,
    onMouseOver: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).func,
    intl: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).object,
    triggerProps: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).object,
    shouldSSRWatchButton: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).bool,
    defaultTab: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).number,
    hasRecentlyUnwatchedContent: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).bool
};
const $176bef54c656e043$export$e149a93a7ac7f896 = (0, $js7oX.default)($176bef54c656e043$var$WatchButtonComponent);

});

parcelRegister("h95iD", function(module, exports) {

let $c7b7634e9d2e877c$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $c7b7634e9d2e877c$var$load("glWzP"),
    $c7b7634e9d2e877c$var$load("awqhH"),
    $c7b7634e9d2e877c$var$load("9OSao")
]).then(()=>parcelRequire('jjM3c'));

});

parcelRegister("iIsfI", function(module, exports) {

let $da02406af4475ec6$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $da02406af4475ec6$var$load("awqhH"),
    $da02406af4475ec6$var$load("8hbZ5")
]).then(()=>parcelRequire('j00wp'));

});




//# sourceMappingURL=WatchDialog.8926772e.js.map
